import React from "react"
import { badgeStyle } from "./index.css"

type Props = {
  text: string
}

export function NotificationBadge({ text }: Props): React.JSX.Element {
  return <span className={badgeStyle}>{text}</span>
}
